import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import PrivacyPolicy from './PrivacyPolicy';
import Support from './Support';
import './index.css';

function App() {
  const [language, setLanguage] = useState<'tr' | 'en'>('tr');

  const switchLanguage = (lang: 'tr' | 'en') => {
    setLanguage(lang);
  };

  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <header className="bg-blue-600 text-white p-4">
          <nav className="container mx-auto flex justify-between items-center">
            <div className="flex space-x-4">
              <Link to="/" className="hover:underline">
                {language === 'tr' ? 'Ana Sayfa' : 'Home'}
              </Link>
              <Link to="/privacy-policy" className="hover:underline">
                {language === 'tr' ? 'Gizlilik Politikası' : 'Privacy Policy'}
              </Link>
              <Link to="/support" className="hover:underline">
                {language === 'tr' ? 'Destek' : 'Support'}
              </Link>
            </div>
            <div className="flex space-x-2">
              <Link to="#" onClick={() => switchLanguage('tr')} className="hover:underline">
                Türkçe
              </Link>
              <Link to="#" onClick={() => switchLanguage('en')} className="hover:underline">
                English
              </Link>
            </div>
          </nav>
        </header>

        <main className="flex-grow container mx-auto p-4">
          <Routes>
            <Route path="/" element={<Home language={language} />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy language={language} />} />
            <Route path="/support" element={<Support language={language} />} />
          </Routes>
        </main>

        <footer className="bg-gray-800 text-white p-4 text-center">
          © 2024 Haydi: Akıllı Görev Planlayıcı
        </footer>
      </div>
    </Router>
  );
}

const Home: React.FC<{ language: 'tr' | 'en' }> = ({ language }) => (
  <div className="text-center">
    <h1 className="text-4xl font-bold mb-4">
      {language === 'tr' ? 'Haydi: Akıllı Görev Planlayıcı\'ya Hoş Geldiniz' : 'Welcome to Haydi: Smart Task Planner'}
    </h1>
  </div>
);

export default App;
